import { ReactComponent as RedPatientFlagIconSvg } from '../../../assets/icons/red-patient-flag.svg';
import { ReactComponent as OrangePatientFlagIconSvg } from '../../../assets/icons/orange-patient-flag.svg';
import { ReactComponent as GreenPatientFlagIconSvg } from '../../../assets/icons/green-patient-flag.svg';
import { ReactComponent as RedCircleIconSvg } from '../../../assets/icons/red-circle.svg';
import { ReactComponent as OrangeCircleIconSvg } from '../../../assets/icons/orange-circle.svg';
import { ReactComponent as GreenCircleIconSvg } from '../../../assets/icons/green-circle.svg';
import { ReactComponent as RedClockIconSvg } from '../../../assets/icons/red-clock.svg';
import { ReactComponent as RedCheckIconSvg } from '../../../assets/icons/red-check.svg';
import { ReactComponent as GreenCheckIconSvg } from '../../../assets/icons/green-check.svg';
import { styled } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

export const CaseloadReportDefinitions = {
  Red_Flag: 1,
  Orange_Flag: 2,
  Green_Flag: 3,
  Clock: 20,
  Red_Light: 4,
  Orange_Light: 5,
  Green_Light: 6,
  Red_Check: 17,
  Green_Check: 19,
  Sent: 21,
  Zero: 14,
  NotAtAll: 13,
  Minimal: 12,
  Mild: 11,
  Moderate: 10,
  Moderate_Severe: 9,
  Markedly: 8,
  Severe: 7,
  Yes: 15,
  No: 16,
  Red_Clock: 18,
};

const createStyledTextData = (color: string) =>
  styled('span')<{ isDesktop?: boolean }>(({ isDesktop }) => ({
    fontSize: isDesktop ? '12px' : '16px',
    color,
  }));

const StyledRedTextData = createStyledTextData('red');
const StyledOrangeTextData = createStyledTextData('orange');
const StyledGreenTextData = createStyledTextData('green');

  const IconMapping: { [type: string]: (isDesktop?: boolean) => JSX.Element } = {
    [CaseloadReportDefinitions.Red_Flag]: () => <RedPatientFlagIconSvg />,
    [CaseloadReportDefinitions.Orange_Flag]: () => <OrangePatientFlagIconSvg />,
    [CaseloadReportDefinitions.Green_Flag]: () => <GreenPatientFlagIconSvg />,
    [CaseloadReportDefinitions.Red_Light]: () => <RedCircleIconSvg />,
    [CaseloadReportDefinitions.Orange_Light]: () => <OrangeCircleIconSvg />,
    [CaseloadReportDefinitions.Green_Light]: () => <GreenCircleIconSvg />,
    [CaseloadReportDefinitions.Clock]: () => <RedClockIconSvg />,
    [CaseloadReportDefinitions.Red_Clock]: () => <RedClockIconSvg />,
    [CaseloadReportDefinitions.Red_Check]: () => <RedCheckIconSvg />,
    [CaseloadReportDefinitions.Green_Check]: () => <GreenCheckIconSvg />,
    [CaseloadReportDefinitions.Sent]: (isDesktop) => <StyledGreenTextData isDesktop={isDesktop}>Sent</StyledGreenTextData>,
    [CaseloadReportDefinitions.Zero]: (isDesktop) => <StyledGreenTextData isDesktop={isDesktop}>0</StyledGreenTextData>,
    [CaseloadReportDefinitions.NotAtAll]: (isDesktop) => <StyledGreenTextData isDesktop={isDesktop}>Not at all</StyledGreenTextData>,
    [CaseloadReportDefinitions.Minimal]: (isDesktop) => <StyledGreenTextData isDesktop={isDesktop}>Minimal</StyledGreenTextData>,
    [CaseloadReportDefinitions.Mild]: (isDesktop) => <StyledGreenTextData isDesktop={isDesktop}>Mild</StyledGreenTextData>,
    [CaseloadReportDefinitions.Moderate]: (isDesktop) => <StyledOrangeTextData isDesktop={isDesktop}>Moderate</StyledOrangeTextData>,
    [CaseloadReportDefinitions.Moderate_Severe]: (isDesktop) => <StyledRedTextData isDesktop={isDesktop}>Moderately Severe</StyledRedTextData>,
    [CaseloadReportDefinitions.Markedly]: (isDesktop) => <StyledRedTextData isDesktop={isDesktop}>Markedly</StyledRedTextData>,
    [CaseloadReportDefinitions.Severe]: (isDesktop) => <StyledRedTextData isDesktop={isDesktop}>Severe</StyledRedTextData>,
    [CaseloadReportDefinitions.Yes]: (isDesktop) => <StyledRedTextData isDesktop={isDesktop}>Yes</StyledRedTextData>,
    [CaseloadReportDefinitions.No]: (isDesktop) => <StyledGreenTextData isDesktop={isDesktop}>No</StyledGreenTextData>,
  };

export default function CaseloadReportIcon({ isDesktop, type }: { isDesktop?: boolean; type: number}) {
  const isPatientFlag = type === CaseloadReportDefinitions.Red_Flag ||
    type === CaseloadReportDefinitions.Orange_Flag ||
    type === CaseloadReportDefinitions.Green_Flag;

  const isIcon = type === CaseloadReportDefinitions.Red_Flag ||
    type === CaseloadReportDefinitions.Orange_Flag ||
    type === CaseloadReportDefinitions.Green_Flag ||
    type === CaseloadReportDefinitions.Red_Light ||
    type === CaseloadReportDefinitions.Orange_Light ||
    type === CaseloadReportDefinitions.Green_Light ||
    type === CaseloadReportDefinitions.Clock ||
    type === CaseloadReportDefinitions.Red_Clock ||
    type === CaseloadReportDefinitions.Red_Check ||
    type === CaseloadReportDefinitions.Green_Check;

  return isIcon ? (
    <SvgIcon sx={{
        fontSize: isDesktop
          ? (isPatientFlag
            ? 33 : 30)
          : 36}}
          viewBox={isDesktop ? (isPatientFlag ? '0 0 24 24' : '0 -2 20 24') : (isPatientFlag ? '2 0 20 24' :'0 -2 13 24')}
      >
      {IconMapping[type]?.(isDesktop)}
    </SvgIcon>
  ): (
  <>{IconMapping[type]?.(isDesktop)}</>
  );
}
